module.exports = __webpack_public_path__ + "img/prolungato_mediale_dx.e8a99f45.png";